import dashboard from "../../assets/home.svg";
import prexo from "../../assets/prexo.svg";
import vrp from "../../assets/vrp.svg";
import openBox from "../../assets/openBox.svg";
import spare from "../../assets/spare.svg";
import new_phone from "../../assets/new_phone.svg";
import payment from "../../assets/payment.svg";
import profile from "../../assets/profile.svg";
import advertisement from "../../assets/advertisement__sidebar.svg";
import coupon from "../../assets/coupon.svg";

export const dropdowns = [
  {
    id: "inventory",
    title: "Manage Inventory",
    options: [
      { id: "spares", image: spare, name: "Spares", path: "inventory/spares" },
      { id: "vrp", image: vrp, name: "VRP", path: "inventory/vrp" },
      {
        id: "new_phones",
        image: new_phone,
        name: "New Phones",
        path: "inventory/new_phones",
      },
      {
        id: "openBox",
        image: openBox,
        name: "Open Box",
        path: "inventory/open_box",
      },
      // { id: "prexo", image: prexo, name: "Prexo", path: "prexo" },
    ],
  },
  {
    id: "masters",
    title: "Manage Masters",
    options: [
      { id: "vrp", image: vrp, name: "VRP", path: "masters/vrp" },
      { id: "spares", image: spare, name: "Spares", path: "masters/spares" },
      {
        id: "new_phones",
        image: new_phone,
        name: "New Phones",
        path: "masters/new_phones",
      },
      {
        id: "openBox",
        image: openBox,
        name: "Open Box",
        path: "masters/open_box",
      },
      // { id: "prexo", image: prexo, name: "Prexo", path: "masters/prexo" },
    ],
  },
];

export const withoutDropdowns = [
  { id: "home", image: dashboard, name: "Home", path: "/" },
  {
    id: "advertisement",
    image: advertisement,
    name: "Advertisement",
    path: "advertisement",
  },
  {
    id: "orders",
    image: payment,
    name: "Orders",
    path: "orders",
  },
  {
    id: "cancellations",
    image: payment,
    name: "Cancellations",
    path: "cancellations",
  },
  {
    id: "refunds",
    image: payment,
    name: "Refunds",
    path: "refunds",
  },
  {
    id: "refund_payments",
    image: payment,
    name: "Refund Initiation",
    path: "refund_payments",
  },
  {
    id: "retailers",
    image: profile,
    name: "Retailers",
    path: "retailers",
  },
  {
    id: "coupons",
    image: coupon,
    name: "Coupons",
    path: "coupons",
  },
  {
    id: "blogs",
    image: coupon,
    name: "Blogs",
    path: "blogs",
  },
];
